import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type HeatTone = 'good' | 'mid' | 'low';

export interface HeatMatrixCell {
  value: string;
  tone?: HeatTone;
}

export interface HeatMatrixRow {
  label: string;
  cells: HeatMatrixCell[];
}

@Component({
  selector: 'lib-heat-matrix-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './heat-matrix-table.component.html',
})
export class HeatMatrixTableComponent {
  @Input() rowHeader = '';
  @Input() columns: string[] = [];
  @Input() rows: HeatMatrixRow[] = [];
  @Input() loading = false;

  readonly skeletonRows = [1, 2, 3, 4, 5];

  readonly toneClass: Record<HeatTone, string> = {
    good: 'bg-[#6b7a66]',
    mid: 'bg-[#93701E]',
    low: 'bg-[#937259]',
  };
}
